import { createApp } from '@app/adapters/create-app'

import SfAssistantChecksUnreadCount from '../components/sf-assistant-checks-unread-count.vue'

window.onDomLoad(function ($doc) {
  const element = $doc[0].querySelector(
    '[data-behaviour="sf-assistant-checks-unread-count"]'
  ) as HTMLElement

  if (element) {
    const { class: className, workflow: workflowId } = element.dataset ?? {}

    createApp(SfAssistantChecksUnreadCount, {
      className,
      workflowId: workflowId ? parseInt(workflowId) : undefined,
    }).mount(element)
  }
})
